import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Icon, Table, TableColumnOpcoes } from '@components';
import { getHeaders, reset as resetHeaders } from '@ducks/conectoresHeaders';

export default function TableHeaders() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  const headers = useSelector(({ conectoresHeaders }) => conectoresHeaders.get('headers').toArray());
  const loadingHeaders = useSelector(({ conectoresHeaders }) => conectoresHeaders.get('loadingHeaders'));

  const handleSearch = () => {
    dispatch(getHeaders(id));
  };

  const handleReset = () => {
    dispatch(resetHeaders());
  };

  useEffect(() => {
    handleReset();
  }, []);

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Header',
      dataIndex: 'nmHeader',
      key: 'nmHeader',
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '7%',
      render: (text, item) => (
        <TableColumnOpcoes>
          <Icon.Edit action={() => history.push(`/conectores/configuracao/${id}/header/${item.id}`)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey='id' columns={columns} dataSource={headers} loading={loadingHeaders} hidePagination />;
}
